import { render, staticRenderFns } from "./DeviceLegend.vue?vue&type=template&id=3d05ab73&scoped=true"
import script from "./DeviceLegend.vue?vue&type=script&lang=js"
export * from "./DeviceLegend.vue?vue&type=script&lang=js"
import style0 from "./DeviceLegend.vue?vue&type=style&index=0&id=3d05ab73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d05ab73",
  null
  
)

export default component.exports